import { VERSION_NAME_MAPPING_KEY } from "utils/ContentFeedCreation";

export const DEFAULT_FEED_MAPPINGS = {
	[VERSION_NAME_MAPPING_KEY]: {
		id: 1,
		name: VERSION_NAME_MAPPING_KEY,
		mappingElement: undefined,
		allowEmpty: false,
	},
};
